import request from '@/utils/request'

// 查询业主列表
export function queryAdminOwners(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/owner.queryAdminOwners',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to query owners'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询管理小区列表（物业端使用我的入驻小区接口）
export function listAdminCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      // 后端限制 community.listAdminCommunitys 仅运营团队可用，
      // 这里统一切换为查询当前账号入驻小区的接口，保持原方法名兼容旧代码。
      url: '/community.listMyEnteredCommunitys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to list communities'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}